import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer
} from "recharts";
import styles from "./SimpleBarChart.module.scss";
// import { convertApiDate } from "../../util/DateUtil";

export default function SimpleBarChart({ data, identifier }: any) {
  return (
    <div
      style={{ padding: "20px", marginLeft: "-40px" }}
      className={styles.container}
    >
      <ResponsiveContainer width="90%" height={250}>
        <BarChart
          width={500}
          height={250}
          data={data}
          margin={{
            top: 5,
            right: 30,
            left: 20,
            bottom: 5
          }}
          barSize={20}
          barGap={3}
        >
          <XAxis
            dataKey={`${identifier}`}
            scale="point"
            padding={{ left: 50, right: 10 }}
          />
          <YAxis dataKey="total" axisLine={false} tickLine={false} />
          <Tooltip />

          <CartesianGrid strokeDasharray="0 0" vertical={false} />
          <Bar
            dataKey="success"
            fill="#16A33F"
            // background={{ fill: "#ffffff" }}
          />
          <Bar
            dataKey="failed"
            fill="#EB5757"
            // background={{ fill: "#ffffff" }}
          />
          <Bar
            dataKey="pending"
            fill="#E8BB00"
            // background={{ fill: "#ffffff" }}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
